import React from 'react';
import { PopupTriggerProps } from '../types';

export const PopUpTrigger = (_props: PopupTriggerProps): JSX.Element => <></>;
